import {createContext, useContext} from 'react'

import {noop} from '@sdox/utils'

import type {SlideshowItem} from './'

type SlideshowContextState = {
  showPrevious: () => void
  showNext: () => void
  showIndex: (index: number) => void
  currentIndex: number
  items: SlideshowItem[]
}

export const SlideshowContext = createContext<SlideshowContextState>({
  showPrevious: noop,
  showNext: noop,
  showIndex: noop,
  currentIndex: 0,
  items: [],
})

export const useSlideshowContext = () => {
  const context = useContext(SlideshowContext)
  if (!context) {
    throw new Error('useSlideshowContext must be used within SlideshowContext.Provider')
  }

  return context
}
